import { sb } from '../../supabase.ts';
import { escapeHtml } from '../../main.ts';

export async function renderOtherSchoolLoginPage(app: HTMLElement): Promise<void> {
  const TABLE = 'button_status';

  app.innerHTML = `
    <div class="login-page-wrapper" style="
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 24px;
      background: radial-gradient(circle at 50% 50%, rgba(16, 185, 129, 0.08), transparent 45%), linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
      color: #334155;
    ">
      <div class="login-card-premium" style="
        width: 100%;
        max-width: 480px;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 16px;
        padding: 32px;
        box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);
      ">
        <div class="login-header-premium" style="text-align: center; margin-bottom: 24px;">
          <div class="login-icon-wrapper" style="
            width: 64px;
            height: 64px;
            background: linear-gradient(135deg, #10b981, #059669);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 16px;
            box-shadow: 0 8px 24px rgba(16, 185, 129, 0.2);
          ">
            <span style="font-size: 32px;">🔑</span>
          </div>
          <h1 style="font-size: 24px; font-weight: 850; color: #0f172a; margin: 0 0 8px 0; font-family: 'Outfit', sans-serif;">FMHS School Login</h1>
          <p style="font-size: 14px; color: #64748b; margin: 0;">Select your username and enter your password.</p>
        </div>
 
        <div class="login-body-premium">
          <div style="margin-bottom: 18px;">
            <label for="buttonSelect" style="display: block; font-size: 12px; font-weight: 700; color: #64748b; text-transform: uppercase; margin-bottom: 8px;">User Name</label>
            <select id="buttonSelect" style="
              width: 100%;
              padding: 12px 16px;
              background: #ffffff;
              border: 1px solid rgba(0, 0, 0, 0.12);
              border-radius: 10px;
              color: #0f172a;
              font-size: 14px;
              outline: none;
              cursor: pointer;
              transition: border-color 0.2s;
            ">
              <option value="">Loading...</option>
            </select>
          </div>
 
          <div id="passwordWrap" style="display: none; margin-bottom: 18px;">
            <label for="passwordInput" style="display: block; font-size: 12px; font-weight: 700; color: #64748b; text-transform: uppercase; margin-bottom: 8px;">Password</label>
            <input id="passwordInput" type="password" placeholder="Enter password" style="
              width: 100%;
              padding: 12px 16px;
              background: #ffffff;
              border: 1px solid rgba(0, 0, 0, 0.12);
              border-radius: 10px;
              color: #0f172a;
              font-size: 14px;
              outline: none;
              transition: border-color 0.2s;
            " />
          </div>
 
          <button id="loginBtn" disabled style="
            width: 100%;
            padding: 12px;
            background: linear-gradient(135deg, #10b981, #059669);
            border: none;
            border-radius: 10px;
            color: #ffffff;
            font-size: 15px;
            font-weight: 700;
            cursor: pointer;
            transition: all 0.2s;
          ">Login</button>
 
          <div id="alert" style="color: #ef4444; font-size: 13px; min-height: 20px; margin-top: 14px; text-align: center; font-weight: 600;"></div>
        </div>
      </div>
      
      <div style="margin-top: 24px; text-align: center; font-size: 12px; color: #64748b;">
        <p>© ${new Date().getFullYear()} Feni Model High School · Powered by Sikhanobish</p>
      </div>
    </div>
  `;

  const selectEl = document.getElementById('buttonSelect') as HTMLSelectElement;
  const passwordWrap = document.getElementById('passwordWrap') as HTMLDivElement;
  const passwordInput = document.getElementById('passwordInput') as HTMLInputElement;
  const loginBtn = document.getElementById('loginBtn') as HTMLButtonElement;
  const alertEl = document.getElementById('alert') as HTMLDivElement;

  let rows: any[] = [];

  function setAlert(msg = '') {
    alertEl.textContent = msg;
  }

  function getSelectedRow() {
    const name = selectEl.value;
    return rows.find(r => String(r.button_name || '') === name) || null;
  }

  function updatePasswordVisibility() {
    const row = getSelectedRow();
    const hasPassword = !!(row && row.button_password && String(row.button_password).trim() !== '');
    passwordWrap.style.display = hasPassword ? 'block' : 'none';
    loginBtn.disabled = !selectEl.value;
    if (!hasPassword) passwordInput.value = '';
  }

  selectEl.addEventListener('change', updatePasswordVisibility);

  passwordInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      loginBtn.click();
    }
  });

  loginBtn.addEventListener('click', () => {
    setAlert('');
    const row = getSelectedRow();
    if (!row) {
      setAlert('Select a User name first.');
      return;
    }
    const requiredPassword = row.button_password ? String(row.button_password) : '';
    const needsPassword = requiredPassword.trim() !== '';
    if (needsPassword) {
      const entered = (passwordInput.value || '').trim();
      if (!entered) {
        setAlert('Password required.');
        return;
      }
      if (entered !== requiredPassword) {
        setAlert('Wrong password.');
        return;
      }
    }

    try {
      localStorage.setItem('adminButton', String(row.button_name));
      const now = Date.now();
      localStorage.setItem('adminLoginAt', String(now));
      localStorage.setItem('adminLastActivity', String(now));
    } catch (e) {
      console.error(e);
    }
    window.location.href = `/other_school_dashboard?*${encodeURIComponent(row.button_name)}`;
  });

  // Load username buttons
  async function loadButtons() {
    setAlert('');
    selectEl.innerHTML = '<option value="">Loading...</option>';
    try {
      const { data, error } = await sb.from(TABLE).select('button_name, button_password, button_status');
      if (error) throw error;

      rows = (data || []).filter(r => {
        if (!r || !r.button_name) return false;
        const pwd = String(r.button_password || '').trim();
        if (!pwd) return false;
        const status = String(r.button_status || '').toLowerCase();
        if (status.includes('disable') || status.includes('deactive')) return false;
        return true;
      });

      if (!rows.length) {
        selectEl.innerHTML = '<option value="">No active buttons available</option>';
        selectEl.disabled = true;
        return;
      }

      selectEl.disabled = false;
      selectEl.innerHTML = '<option value="">Select</option>';
      rows.forEach(r => {
        const opt = document.createElement('option');
        opt.value = r.button_name;
        opt.textContent = r.button_name;
        selectEl.appendChild(opt);
      });
    } catch (e: any) {
      console.error(e);
      selectEl.innerHTML = '<option value="">Failed to load</option>';
      setAlert('Failed to load button list.');
    }
  }

  await loadButtons();

  // If already logged in, redirect
  try {
    const s = localStorage.getItem('adminButton');
    if (s) {
      const last = Number(localStorage.getItem('adminLastActivity') || 0);
      const timeout = 30 * 60 * 1000; // 30 mins
      const now = Date.now();
      if (last && (now - last) <= timeout) {
        localStorage.setItem('adminLastActivity', String(now));
        window.location.href = `/other_school_dashboard?*${encodeURIComponent(s)}`;
      }
    }
  } catch (e) {
    console.error(e);
  }
}
